<template>
  <div export-element-ignore
       :title="title"
       v-b-tooltip.hover.nofade="toolTipDelay">

    <div :class="{ screenSpinner: isExporting }"></div>

    <!-- Only one element to export -->
    <b-button v-if="!additionalElements" variant="primary"
              @click="exportImage(elementRef)"
              :disabled="disabled || disabledInternal">
      <font-awesome-icon icon="camera" />
    </b-button>

    <!-- Multiple elements to export -->
    <b-dropdown v-if="additionalElements" split variant="primary"
              @click="exportImage(elementRef)"
              :right="right"
              :disabled="disabled || disabledInternal">
      <template slot="button-content">
        <font-awesome-icon icon="camera" />
      </template>
      <b-dropdown-item v-for="additionalElement in additionalElements"
                       :key="additionalElement.Name"
                       @click="exportImage(additionalElement.ElementRef)">
                       {{ additionalElement.Name }}
      </b-dropdown-item>
    </b-dropdown>
  </div>
</template>

<script>
import FileSaver from 'file-saver'
import domtoimage from '@/services/dom-to-image'
import BrowserDetection from '@/services/BrowserDetection'

export default {
  name: "ExportElementButton",

  props: {
    elementRef: String,
    additionalElements: Array,
    fileName: String,
    right: { default: false, type:Boolean },
    disabled: { default: false, type:Boolean }
  },

  data() {
    return {
      isExporting: false,
      toolTipDelay: { delay: { "show": 500, "hide": 100 } }
    }
  },

  computed: {
    title: function() {
      return this.disabledInternal ? this.$t('Webportal.ExportToImageNotAvailable') : this.$t('Webportal.ExportToImage');
    },

    disabledInternal: function() {
      return BrowserDetection.isFirefox() === false && BrowserDetection.isChrome() === false;
    }
  },

  methods: {
    downloadImage: function(element) {
      return Promise.resolve(
          domtoimage.toBlob(element, {
            filter: node => {
              // Ignore all marked elements (including this button itself)
              return !node.hasAttribute || !node.hasAttribute("export-element-ignore");
            }
          }).then(blob => {
              FileSaver.saveAs(blob, `${this.fileName}.png`);
          }).catch(error => {
              console.error(error);
          })
        );
    },

    exportImage(elementRef) {
      var element = this.$parent.$refs[elementRef];
      if (element)
      {
        this.isExporting = true;
        
        setTimeout(() => {
          this.downloadImage(element)
          .then(_ => { this.isExporting = false; })
          .catch(_ => { this.isExporting = false; });
        }, 100);
      } else {
        console.warn('ExportElementButton - specified ElementRef is not defined: ' + elementRef + '!');
      }
    },
  }
}
</script>
